import { useContext } from "react"
import { Context } from "./Context"

export const useVersion = () => {
  return useContext(Context)
}
